__webpack_public_path__ = altosoft.baseAppPath + '../build/';

import(/* webpackChunkName: "fonts-modern" */ '@Styles/fonts/fonts-modern.scss');

function init() {
    const fonts = ['Noto Sans']
        .concat(['Noto Sans SC', 'Noto Sans JP'][altosoft.locale === 'zh-hans' ? 'slice' : 'reverse'](), [
            'Open Sans',
            'Helvetica',
            'Arial',
            'sans-serif'
        ])
        .join(', ');
    altosoft.fontInfo = {
        fallback: document.body.style.fontFamily = fonts,
        assetName: 'fonts-modern'
    };
}

if (document.body) {
    init();
} else {
    document.addEventListener('DOMContentLoaded', init);
}
